module.exports = __webpack_public_path__ + "static/media/blue_nebula_UP.b964fda5.png";